import * as React from 'react';
import { useRadioGroup } from '@mui/material/RadioGroup';
import { Typography, Box } from '@mui/material';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import { containerOption, optionLabel, containerCenter } from './styles';
interface IEQUIPMENTcustom extends FormControlLabelProps {
  description: string;
  Icon: React.FC;
  equipment?: string;
  handleChange?: (event: string | React.ChangeEvent<HTMLInputElement>) => void;
}

export default function MyFormControlLabel({ equipment: _equipment, Icon, handleChange, ...props }: IEQUIPMENTcustom) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }
  return (
    <Box
      sx={() => containerOption(checked)}
      onClick={() => {
        if (radioGroup && handleChange && typeof props.value === 'string') {
          handleChange(props.value);
        }
      }}
    >
      <Box sx={containerCenter}>
        <FormControlLabel
          labelPlacement="start"
          componentsProps={{
            typography: {
              fontSize: 13,
              fontWeight: 'bold'
            }
          }}
          sx={optionLabel}
          {...props}
        />
        <Icon />
      </Box>

      <Typography variant="body2"> {props.description} </Typography>
    </Box>
  );
}
